module.exports = __webpack_public_path__ + "img/131-217bf6.png";